<div class="dtf-accountdetails admin-banners-page">
  <div class="dtf-alertpage"></div>
  <div class="container_dashboard">
  <div class="cardlike">
  <h1 class="mercedes-me-login__column-headline2">Manage Banners</h1>
  <p class="paragraph1">Important: Please test all changes in the staging environment before applying them to production.Ensure you back up the existing content, as any updates will overwrite the current copy and cannot be undone.All changes are pushed to the website immediately.</p>
  </div>
  <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner loading-container">
    <!--Spinner on Login Load-->
    <div class="demo-container">
      <span>{{ 'Invoice.Loading' | translate }}</span>
      <div class="progress-bar">
        <div class="progress-bar-value"></div>
      </div>
    </div>
  </div>
  <div class="table-toolbar">
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Search banners</mat-label>
      <input matInput (input)="applyFilter($event)" placeholder="Type, name, country..." />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div class="table-wrapper">
    <table class="banner-table redesigned-table" matSort (matSortChange)="sortData($event)">
      <colgroup>
        <col class="status-col">
        <col class="banner-name-col">
        <col class="country-col">
        <col class="copy-preview-col">
        <col class="schedule-col">
        <col class="actions-col">
      </colgroup>
      <thead>
        <tr>
          <th class="status-col" mat-sort-header="bannerType">Type</th>
          <th class="banner-name-col" mat-sort-header="bannerHeader">Name</th>
          <th class="country-col" mat-sort-header="bannerCountry">Country</th>
          <th class="copy-preview-col">Copy Preview</th>
          <th class="schedule-col" mat-sort-header="startDate">Schedule</th>
          <th class="actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let banner of dataSource.filteredData" class="banner-row">
          <td class="status-cell">
            <div class="status-badge active">
              <span class="checkmark">✓</span>
              <span class="status-text">{{ banner.bannerType }}</span>
            </div>
          </td>
          <td class="banner-name-cell">{{ banner.bannerHeader }}</td>
          <td class="country-cell">{{ banner.bannerCountry }}</td>
          <td class="copy-preview-cell">{{ banner.bannerCopy | slice:0:30 }}...</td>
          <td class="schedule-cell">
            <span class="date-range">
              {{ banner.startDate | date: 'MMM dd' }} → {{ banner.endDate | date: 'MMM dd' }}
            </span>
          </td>
          <td class="actions-cell">
            <button class="edit-btn" (click)="editBanner(banner)" title="Edit Banner">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Save Button -->
  <!-- <div class="save-row-wrap">
    <div class="save-row mt-4">
      <button class="mbfs-button" (click)="saveData()">Save</button>
      <div *ngIf="successMessage" class="success-banner">
        {{ successMessage }}
      </div>
    </div>
  </div> -->
  </div>
</div>